import { useEffect } from 'react';

import { datePickerPopperClassName } from './datePickerPopperConfig';

export const usePreventDatePickerBlurClose = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const onMouseDown = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      if (target.closest('.react-datepicker') || target.closest(`.${datePickerPopperClassName}`)) {
        event.preventDefault();
      }
    };

    document.addEventListener('mousedown', onMouseDown, true);
    return () => document.removeEventListener('mousedown', onMouseDown, true);
  }, [isOpen]);
};
